/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCaseMessageAttachmentDTO interface.
 */
export function instanceOfWarehouseCaseMessageAttachmentDTO(value) {
    return true;
}
export function WarehouseCaseMessageAttachmentDTOFromJSON(json) {
    return WarehouseCaseMessageAttachmentDTOFromJSONTyped(json, false);
}
export function WarehouseCaseMessageAttachmentDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'mimeType': json['mimeType'] == null ? undefined : json['mimeType'],
        'sizeBytes': json['sizeBytes'] == null ? undefined : json['sizeBytes'],
    };
}
export function WarehouseCaseMessageAttachmentDTOToJSON(json) {
    return WarehouseCaseMessageAttachmentDTOToJSONTyped(json, false);
}
export function WarehouseCaseMessageAttachmentDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fileName': value['fileName'],
        'mimeType': value['mimeType'],
        'sizeBytes': value['sizeBytes'],
    };
}
